import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-plaze-details',
  templateUrl: './plaze-details.component.html',
  styleUrls: ['./plaze-details.component.scss']
})
export class PlazeDetailsComponent implements OnInit {

  selectedTab:number = 0;
  video_processed: any[]=[];
  kms_plaza_details: any[]=[];
  idle_hrs_data: any[]=[];
  total_video_processed: any[]=[];
  total_kms_plaza_details: any[]=[];
  total_idle_hrs_data: any[]=[];
  total_day_idle_data: any = 0;
  total_night_idle_data: any = 0;
  total_day_night_idle_data: any = 0;
  total_day_night_kms: any = 0;
  total_day_kms: any = 0;
  total_night_kms: any = 0;

  constructor(public dialog:MatDialog,
    public dialogRef: MatDialogRef<PlazeDetailsComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
  ) { 
    if(data.videos_processed_tps_data && data.videos_processed_tps_data.individual_plaza_details && data.videos_processed_tps_data.individual_plaza_details.length == 1){
      if(data.videos_processed_tps_data.individual_plaza_details[0].plaza != data.site_name){
        data.videos_processed_tps_data.individual_plaza_details.forEach((vp : any) => {
          this.total_video_processed.push(vp);
        });
      }
    }
    else{
      data.videos_processed_tps_data.individual_plaza_details.forEach((vp : any) => {
        this.total_video_processed.push(vp);
      });
    }
    this.video_processed = data.videos_processed_tps_data.all_plaza_details;
    this.getTotalKmsCoveredOfData(data.kms_covered_tps_data);
    if(data.kms_covered_tps_data && data.kms_covered_tps_data.individual_kms_covered_details && data.kms_covered_tps_data.individual_kms_covered_details.length == 1){
      if(data.kms_covered_tps_data.individual_kms_covered_details[0].plaza != data.site_name){
        data.kms_covered_tps_data.individual_kms_covered_details.forEach((kms : any) => {
          this.total_kms_plaza_details.push(kms);
        });
      }
    }
    else{
      data.kms_covered_tps_data.individual_kms_covered_details.forEach((kms : any) => {
        this.total_kms_plaza_details.push(kms);
      });
    }
    this.kms_plaza_details = data.kms_covered_tps_data.all_kms_plaza_details;
    this.getTotalIdleHoursOfData(data.idle_hrs_tps_data);

    if(data.idle_hrs_tps_data && data.idle_hrs_tps_data.individual_plaza_details && data.idle_hrs_tps_data.individual_plaza_details.length == 1){
      if(data.idle_hrs_tps_data.individual_plaza_details[0].plaza != data.site_name){
        data.idle_hrs_tps_data.individual_plaza_details.forEach((idle : any) => {
          this.total_idle_hrs_data.push(idle);
        });
      }
    }
    else{
      data.idle_hrs_tps_data.individual_plaza_details.forEach((idle : any) => {
        this.total_idle_hrs_data.push(idle);
      });
    }
    this.idle_hrs_data = data.idle_hrs_tps_data.all_plaza_details;
  }

  ngOnInit(): void {
  }

  close(){
    this.dialog.closeAll();
  }

  displayVideoProcessedDetails(){
    this.selectedTab = 0;
  }

  displayKMsCoveredDetails(){
    this.selectedTab = 1;
  }

  displayIdleHoursDetails(){
    this.selectedTab = 2;
  }

  onLHSAndRHSClick(centerBgId: string){
    let d = document.getElementById(centerBgId);
    d.classList.remove('center-bg-lhs', 'center-bg-rhs');
    document.getElementById(centerBgId).classList.add('center-bg');
  }

  onLHSClick(centerBgId: string){
    let d = document.getElementById(centerBgId);
    d.classList.remove('center-bg-rhs', 'center-bg', 'center-bg-lhs-rhs');
    document.getElementById(centerBgId).classList.add('center-bg-lhs');
    
  }

  onRHSClick(centerBgId: string){
    let d = document.getElementById(centerBgId);
    d.classList.remove('center-bg-lhs', 'center-bg', 'center-bg-lhs-rhs');
    document.getElementById(centerBgId).classList.add('center-bg-rhs');
  }

  getTotalIdleHoursOfData(data:any) {
    if (!data) {
        return;
    }
    if((data.all_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].day + data.all_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].day) != 0){
      let mins = (data.all_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].day + data.all_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].day);
      let h: any = Math.floor(mins / 60);
      let m: any = Math.round(mins % 60);
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      this.total_day_idle_data = h && m ? `${+h}hrs:${+m}mins` : '-';
    }
    if((data.all_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].night + data.all_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].night) != 0){
      let mins = (data.all_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].night + data.all_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].night);
      let h: any = Math.floor(mins / 60);
      let m: any = Math.round(mins % 60);
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      this.total_night_idle_data = h && m ? `${+h}hrs:${+m}mins` : '-';
    }
    if((data.all_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].day + data.all_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].day + 
      data.all_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].night + data.all_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].night) != 0){
      let mins = (data.all_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].day + data.all_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].day + 
        data.all_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].night + data.all_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].night);
      let h: any = Math.floor(mins / 60);
      let m: any = Math.round(mins % 60);
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      this.total_day_night_idle_data = h && m ? `${+h}hrs:${+m}mins` : '-';
    }

    data.individual_plaza_details.forEach((value : any) => {
      if((value["lhs/rhs"].lhs["day/night"].day + value["lhs/rhs"].rhs["day/night"].day) != 0){
        let mins = (value["lhs/rhs"].lhs["day/night"].day + value["lhs/rhs"].rhs["day/night"].day);
        let h: any = Math.floor(mins / 60);
        let m: any = Math.round(mins % 60);
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        value.day = h && m ? `${+h}hrs:${+m}mins` : '-';
      }
      else{
        value.day = 0 ;
      }
      if((value["lhs/rhs"].lhs["day/night"].night + value["lhs/rhs"].rhs["day/night"].night) != 0){
        let mins = (value["lhs/rhs"].lhs["day/night"].night + value["lhs/rhs"].rhs["day/night"].night);
        let h: any = Math.floor(mins / 60);
        let m: any = Math.round(mins % 60);
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        value.night = h && m ? `${+h}hrs:${+m}mins` : '-';
      }
      else{
        value.night = 0 ;
      }
      if((value["lhs/rhs"].lhs["day/night"].day + value["lhs/rhs"].rhs["day/night"].day + 
        value["lhs/rhs"].lhs["day/night"].night + value["lhs/rhs"].rhs["day/night"].night) != 0){
        let mins = (value["lhs/rhs"].lhs["day/night"].day + value["lhs/rhs"].rhs["day/night"].day + 
          value["lhs/rhs"].lhs["day/night"].night + value["lhs/rhs"].rhs["day/night"].night);
        let h: any = Math.floor(mins / 60);
        let m: any = Math.round(mins % 60);
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        value.total = h && m ? `${+h}hrs:${+m}mins` : '-';
      }
      else{
        value.total = 0 ;
      }
    })
  }

  getTotalKmsCoveredOfData(data:any) {
    if (!data) {
        return;
    }
    if((data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].day + data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].day) != 0){
      let total = (data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].day + data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].day);
      this.total_day_kms = total.toFixed(3);
    }
    if((data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].night + data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].night) != 0){
      let total = (data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].night + data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].night);
      this.total_night_kms  = total.toFixed(3);
    }
    if((data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].day + data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].day + 
      data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].night + data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].night) != 0){
      let total = (data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].day + data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].day + 
        data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].lhs["day/night"].night + data.all_kms_plaza_details["lhs/rhs/all_plazas_data"].rhs["day/night"].night);
      this.total_day_night_kms = total.toFixed(3);
    }
    data.individual_kms_covered_details.forEach((value : any) => {
      if((value["lhs/rhs"].lhs["day/night"].day + value["lhs/rhs"].rhs["day/night"].day) != 0){
        let total = (value["lhs/rhs"].lhs["day/night"].day + value["lhs/rhs"].rhs["day/night"].day);
        value.day = total.toFixed(3);
      }
      else{
        value.day = 0 ;
      }
      if((value["lhs/rhs"].lhs["day/night"].night + value["lhs/rhs"].rhs["day/night"].night) != 0){
        let total = (value["lhs/rhs"].lhs["day/night"].night + value["lhs/rhs"].rhs["day/night"].night);
        value.night = total.toFixed(3);
      }
      else{
        value.night = 0 ;
      }
      if((value["lhs/rhs"].lhs["day/night"].day + value["lhs/rhs"].rhs["day/night"].day + 
        value["lhs/rhs"].lhs["day/night"].night + value["lhs/rhs"].rhs["day/night"].night) != 0){
        let total = (value["lhs/rhs"].lhs["day/night"].day + value["lhs/rhs"].rhs["day/night"].day + 
          value["lhs/rhs"].lhs["day/night"].night + value["lhs/rhs"].rhs["day/night"].night);
        value.total = total.toFixed(3);
      }
      else{
        value.total = 0 ;
      }
    })
  }


}
